import { featureFlags } from "#/config/featureFlags";
import { ButtonFeatureFlag } from "#/types/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useTradeButtonFeatureFlag = () => {
  const featureFlag = useFeatureFlags<ButtonFeatureFlag>(
    featureFlags.tradeButton,
  );
  const isTradeButtonEnabled = featureFlag?.isEnabled ?? true;
  const tradeButtonTitle = featureFlag?.title ?? "Disabled";

  return { isTradeButtonEnabled, tradeButtonTitle };
};
